;(function($) {
    "use strict";

    $(document).ready(function() {

        let otherCheckbox = null;
        let otherField = null;

        var checkFormRendered = setInterval(function() {
            var formElement = $('afform-areas-of-specialism ul.crm-checkbox-list');

            if (formElement.length) {
                clearInterval(checkFormRendered);
                initializeForm(formElement);
            }
        }, 100); // Check every 100ms until the form is available

        function initializeForm(formElement) {
            setupColumns(formElement);
            moveOtherInputs(formElement);
            setupOtherListener(formElement);
            checkVisibility();

            // As the initial values are loaded by ajax
            CRM.$(document).on("ajaxComplete", function() {
                window.setTimeout(checkVisibility)
            });
        }

        // Function to set up the columns after the <ul> is added
        function setupColumns(list) {
            var items = $(list).children('li');
            var totalItems = items.length;
            var leftColumnCount = Math.ceil(totalItems / 2) + 1;
            items.each(function(index) {
                var column = (index < leftColumnCount) ? 1 : 2;
                var row = (column === 1) ? index + 1 : index - leftColumnCount + 1;

                $(this).css({
                    'grid-column': column,
                    'grid-row': row
                });
            });
        }

        function setupOtherListener(list) {
            const $list = $(list); // Ensure it's a jQuery object
            otherCheckbox = $list.find('input[type="checkbox"]').last();
            otherCheckbox.on('change', checkVisibility);
        }

        function checkVisibility() {
            if (!otherField || !otherField.length) {
                return
            }

            if (otherCheckbox[0].checked) {
                otherField.css({visibility: 'visible'})
            } else {
                otherField.css({visibility: 'hidden'})
                otherField.find('input').val('')
            }
        }

        function moveOtherInputs(list) {
            var $list = $(list); // Ensure it's a jQuery object

            // Find the next <af-field> sibling after the closest <af-field>
            var afFieldToMove = $list.closest('af-field').next('af-field');

            if (afFieldToMove.length > 0) {
                // Ensure the afFieldToMove is wrapped in <li>
                var newListItem = $('<li></li>').append(afFieldToMove);

                // Append the new <li> to the <ul>
                $list.append(newListItem);

                otherField = newListItem;

                // Optionally remove the original <af-field> (not needed here since it's moved)
            }
        }
    });

})(jQuery);
